import { Middleware } from '@nuxt/types';
import { Logger } from '~/helpers/logger';
import { redirectToFallback } from '~/helpers/notFoundFallback';
import { CustomRoutableInterface } from '~/modules/GraphQL/custom-types';
import { usePageStore } from '~/stores/page';

const packageMiddleware: Middleware = async (context) => {
  const pageStore = usePageStore(context.$pinia);
  const { path } = context.route;

  const rootPackageUrl = 'analyspaket';
  const clearUrl = path
    .replace(/[a-z]+\/[cp|]\//gi, '')
    .replace(`/${context.i18n.locale}`, '')
    .replace(`${rootPackageUrl}`, '');

  Logger.debug('middleware/url-resolver', clearUrl);

  const response = await context.app.$vsf.$magento.api.route(clearUrl);
  const { data, errors } = response;

  Logger.debug('middleware/url-resolver/result', { data, errors });

  const results: CustomRoutableInterface | null = data?.route ?? null;

  if (!results || errors?.length) {
    redirectToFallback(context);
    return;
  }

  // TODO: Remove this check when the backend removes '.html' from the expected route
  // Simple analyses live under /analys/:slug, so a simple analysis requested as a package goes there.
  if (results.analysis_type === 'SIMPLE') {
    const slug = path.split('/').filter(Boolean).pop();
    context.redirect(301, context.app.localePath(`/analys/${slug}`));
    return;
  }

  pageStore.$patch((state) => {
    state.routeData = results;
    state.parentRouteData = null;
  });
};

export default packageMiddleware;
